import { render, staticRenderFns } from "./LayoutEnvelope.vue?vue&type=template&id=6895b7f2&"
import script from "./LayoutEnvelope.vue?vue&type=script&lang=js&"
export * from "./LayoutEnvelope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports